export const creditCard = {
    add_new_title: "Add new card",
    add: {
        cardNumber: {
            name: 'Card Number',
            placeholder: 'Card Number',
            required: 'Please enter Card Number',
            too_short: '',
            invalid: '',
        },
        cardName: {
            name: 'Card holder Name',
            placeholder: 'Card holder Name',
            required: 'Please enter Card holder Name',
            too_short: '',
            invalid: '',
        },
        expireDate: {
            name: 'Expiration (MM/YY)',
            placeholder: 'Expiration (MM/YY)',
            required: 'Please enter Expiration',
            too_short: '',
            invalid: 'Incorrect Expiration format (MM/YY)',
        },
        securityCode: {
            name: 'CVV',
            placeholder: 'CVV',
            required: 'Please enter CVV',
            too_short: '',
            invalid: '',
        },
        isDefault: 'Set default',
    },
    info: "Information is encrypted and securely stored.",
    btn_addcard: "Add Card",

    //  #region use with /card page
    credit_debit_title: 'Credit / Debit Card',
    card_notfound: 'There is no credit card yet.',
    default_card: 'Default',
    delete_card: 'Delete',
    modal_del_msg: 'Do you want to delete creditcard',
    confirm_del_btn: 'Confirm'
    //  #end region use with /card page
};
